export var SchemaChangeKind;
(function (SchemaChangeKind) {
    SchemaChangeKind["SCHEMA_CHANGE_KIND_UNSPECIFIED"] = "SCHEMA_CHANGE_KIND_UNSPECIFIED";
    SchemaChangeKind["SCHEMA_CHANGE_KIND_NEW_FIELD"] = "SCHEMA_CHANGE_KIND_NEW_FIELD";
    SchemaChangeKind["SCHEMA_CHANGE_KIND_MISSING_FIELD"] = "SCHEMA_CHANGE_KIND_MISSING_FIELD";
    SchemaChangeKind["SCHEMA_CHANGE_KIND_RETYPED"] = "SCHEMA_CHANGE_KIND_RETYPED";
    SchemaChangeKind["SCHEMA_CHANGE_KIND_CARDINALITY_DRIFT"] = "SCHEMA_CHANGE_KIND_CARDINALITY_DRIFT";
})(SchemaChangeKind || (SchemaChangeKind = {}));
